import { render, staticRenderFns } from "./ResultadosHomeComp.vue?vue&type=template&id=d826a420&scoped=true&"
import script from "./ResultadosHomeComp.vue?vue&type=script&lang=js&"
export * from "./ResultadosHomeComp.vue?vue&type=script&lang=js&"
import style0 from "./ResultadosHomeComp.vue?vue&type=style&index=0&id=d826a420&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d826a420",
  null
  
)

export default component.exports